import React from "react";
import Helmet from "react-helmet"

const Fonts = () => {
    return(
        <Helmet>
            <link 
                href="https://fonts.googleapis.com/css2?family=Dosis:wght@600&family=Roboto:wght@400&display=swap" 
                rel="stylesheet"/>
        </Helmet>
    );
};

export default Fonts;
